<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Select Mode, Manual Vs. Batch-->
				<div class="OptionSelectDiv">
					<h4>Select Mode:</h4>
					<div class="RadioGrid">
						<input type="radio" name="SelectMode" [(ngModel)]="SelectMode" id="Manual" value="Manual" />
						<label for="Manual">Manually Select Students</label>

						<input style="margin-left: 10px" type="radio" name="SelectMode" [(ngModel)]="SelectMode" id="Batch" value="Batch" />
						<label for="Batch">Import File</label>

						<input style="margin-left: 10px" type="radio" name="SelectMode" [(ngModel)]="SelectMode" id="DownloadQR" value="DownloadQR" />
						<label for="DownloadQR">Download QR Codes</label>
					</div>
				</div>

				<!--Manual Mode-->
				<div *ngIf="SelectMode == 'Manual'" class="TopMarinExtra">
					<caass-digital-id-manual-mode (EmailRefresh)="onEmailRefresh()"> </caass-digital-id-manual-mode>
				</div>

				<!--Batch Mode-->
				<div *ngIf="SelectMode == 'Batch'" class="TopMarinExtra">
					<caass-digital-id-batch-mode (EmailRefresh)="onEmailRefresh()"> </caass-digital-id-batch-mode>
				</div>

				<!--Email Log Table-->
				<div *ngIf="SelectMode != 'DownloadQR'" class="TopMarinExtra">
					<p-accordion>
						<p-accordionTab
							header="Email Log {{ EmailLogExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
							[(selected)]="EmailLogExpand"
						>
							<div>
								<caass-digital-id-email-log> </caass-digital-id-email-log>
							</div>
						</p-accordionTab>
					</p-accordion>
				</div>

				<!--Download QR Codes-->
				<div *ngIf="SelectMode == 'DownloadQR'" class="TopMarinExtra">
					<caass-digital-id-print-qr-codes></caass-digital-id-print-qr-codes>
				</div>
			</div>
		</div>
	</div>
</div>
